module.exports = __webpack_public_path__ + "img/112.04d48c32.jpg";